module.exports = __webpack_public_path__ + "static/calle01-c298e6f0edac4a99ba7c743387adc508.jpg";